import { Padding, TableCell, TableHead, TableRow } from "@material-ui/core";
import SwapVertIcon from "@material-ui/icons/SwapVert";
import { ITableColumn } from "components/interfaces";
import { lang } from "i18nLang";

interface IProps {
  className?: string;
  classNameCell?: string;
  columns: ITableColumn[];
  actionColumn?: boolean;
  actionWidth?: number;
  actionAlign?: "right" | "left" | "center" | "justify" | "inherit";
  style?: any;
  fontWeight?: number;
  onClickColumn?: (ev: any, field: string) => void;
}

const HeadTable = ({
  className,
  classNameCell,
  columns,
  actionColumn = false,
  actionWidth = 150,
  actionAlign,
  style = {},
  fontWeight = 400,
  onClickColumn,
}: IProps) => {
  const clmns = actionColumn
    ? [
        ...columns,
        {
          dataKey: "acao",
          label: lang("actions"),
          width: actionWidth,
          align: actionAlign,
        },
      ]
    : columns;

  const handleClickColumn = (ev, field) => {
    if (onClickColumn) onClickColumn(ev, field);
  };

  return (
    <TableHead>
      <TableRow className={className}>
        {clmns.map((column: ITableColumn, index: number) => {
          return (
            <TableCell
              className={classNameCell}
              key={`table-head-cell-${index}`}
              component="th"
              align={column.align as any}
              style={{
                ...style,
                width: column.width,
                fontWeight,
                cursor: onClickColumn ? "pointer" : "default",
              }}
              padding={column.padding as Padding}
              onClick={(ev) => handleClickColumn(ev, column.dataKey)}
            >
              {column.label}
              {column.sorting && (
                <SwapVertIcon style={{ float: "inline-end" }} />
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default HeadTable;
